export enum GuestMailTipStatus {
    None = 0,
    IsCalculated = 1,
    GuestsEnabled = 2,
    GroupHasGuests = 4,
}
